import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {

  constructor(private ws: PostmethodService) { }

  setPassword(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/user/changePassword");
  }

}
